import { getConfig } from '@klpkonsern/appconfig';
import { IconName } from '@klp/design/Illustrations';
import { SidebarMenuItem } from '@klp/layout/Sidebar/classes/SidebarMenuItem';
import { generateRoute } from '@klp/routing';
import type { User } from '@klp/user';

// Extend AppConfigParameters for this module
declare global {
    interface AppConfigParameters {
        WEBAPP_PROJECTDXBO_ENABLE: boolean;
        WEBAPP_PROJECTDXBO_URL_ADMIN: string;
        WEBAPP_PROJECTDXBO_URL_USER: string;
    }
}

export const ProjectDxboModuleName = 'beslutningsportal';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ProjectDxboFrameAccess = (_user?: User): boolean =>
    getConfig('WEBAPP_PROJECTDXBO_ENABLE', false);

export const ProjectDxboRoutes = {
    projectDxbo: () => generateRoute([ProjectDxboModuleName]),
    projectDxboDetails: (path: string) =>
        generateRoute([ProjectDxboModuleName, path]),
};

export const ProjectDxboMenuItems = [
    new SidebarMenuItem({
        route: ProjectDxboRoutes.projectDxbo(),
        matchRoute: ProjectDxboRoutes.projectDxbo(),
        icon: IconName.EDIT,
        translation: 'frontPage.dxboProject',
        access: ProjectDxboFrameAccess,
    }),
];
